// Modal para adicionar um Advogado existente ao processo.
// Seleciona a pessoa desejada e chama cadastrarAdvogado() ao salvar.

import React from "react";
import axios from "axios";

const NovoAdvogadoModal = ({ idProcess, token, responsePessoa }) => {
    function cadastrarAdvogado() {
        const adv = document.querySelector("#nomeAdvogado").value;

        axios
            .post(
                `/api/new/attorney/${idProcess}`,
                { token, adv },
                {
                    withCredentials: true,
                }
            )
            .then((resp) => {
                if (resp.data == 400) {
                    alert("Essa pessoa já está cadastrada como Advogado!");
                } else {
                    window.location = `/ci/pagamentos/${idProcess}`;
                }
            });
    }

    return (
        <div
            className="modal fade"
            id="novoadvogado"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Novo Advogado
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="m-cadastrar-descricaoLbl">
                            Selecione a Pessoa
                        </label>
                        <select
                            className="form-control select2 select2-hidden-accessible"
                            style={{ width: "100%" }}
                            name="adv"
                            id="nomeAdvogado"
                        >
                            {responsePessoa.map((dados, index) => (
                                <option key={index}>{dados.nome}</option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={cadastrarAdvogado}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoAdvogadoModal;
